import { useQuery } from 'react-query';
import { ParticipantBrokerAccountSharedService } from '../../services/wealthlane-finance-integration-services';
import { ParticipantAccountsService } from '../../services/wealthlane-customer-services';

const useGetParticipantTransferAgent = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
) => {
  const participantTransferAgent = useQuery(
    ['getParticipantTransferAgent'],
    async () =>
      handleRequest(
        ParticipantAccountsService.getApiCustomerApiAppParticipantAccountsParticipantTransferAgentAccounts()
      ),
    {
      select(data) {
        return data?.transferAgentAccounts;
      },
    }
  );
  return participantTransferAgent;
};

export default useGetParticipantTransferAgent;
